/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */

import './MarginJournalPage.scss';

import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { navTypes } from 'services/globals';
import BasicLayout from 'components/layouts/BasicLayout';
import { getOwnedActiveAccounts } from 'state/account/AccountSelectors';
import SecureAuth from '../../shared/SecureAuth/SecureAuth';

const MarginJournalPage = () => {
  return (
    <div className="margin-journal-container">
      <BasicLayout
        navType={navTypes.CORE}
        includedLinks={['auth']}
        title="Margin Journal"
        isCustomerWebView={false}>
        <div className="instructions">
          Complete the form to send a request to move cash or securities
        </div>
      </BasicLayout>
    </div>
  );
};

const MarginJournal = () => (
  <SecureAuth>
    <MarginJournalPage />
  </SecureAuth>
);

const mapStateToProps = (state) => {
  return {
    accounts: getOwnedActiveAccounts(state)
  };
};

export default withRouter(connect(mapStateToProps)(MarginJournal));
